import { Badge } from "@app/components/Dashboard/dashboard/ui/badge";
import { DatePicker } from "@app/components/Dashboard/dashboard/ui/date_picker";
import { useDashboardContext } from "@app/components/Dashboard/DashboardProvider";
import { ReportTimeWindow } from "@app/pages/Dashboard";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectSeparator,
} from "@shortsworks/ui";
import { CircleX, X } from "lucide-react";

interface DashboardHeaderProps {
  onChangeTimeWindow?: (
    value: ReportTimeWindow,
    customRange?: { startDate: Date; endDate: Date },
  ) => void;
}

export const DashboardHeader = ({
  onChangeTimeWindow,
}: DashboardHeaderProps) => {
  const {
    timeWindow,
    setTimeWindow,
    setCustomDateRange,
    groupFilter,
    setGroupFilter,
  } = useDashboardContext();

  const handleChangeTimeWindow = (value: string) => {
    setTimeWindow(value as ReportTimeWindow);
  };

  const handleChangeCustomRange = (range: any) => {
    // onChangeTimeWindow('custom', range);
    setTimeWindow("custom");
    setCustomDateRange?.(range);
  };

  return (
    <div className="flex flex-row min-h-10 flex-wrap flex-auto gap-2">
      <Select value={timeWindow} onValueChange={handleChangeTimeWindow}>
        <SelectTrigger style={{ width: "180px" }}>
          <SelectValue placeholder="Select" />
        </SelectTrigger>
        {/* schema 또는 데이터로 처리하기 */}
        <SelectContent>
          <SelectItem value="yesterday">어제</SelectItem>
          <SelectItem value="today">오늘</SelectItem>
          <SelectSeparator />
          <SelectItem value="7d">지난 7일</SelectItem>
          <SelectItem value="14d">지난 14일</SelectItem>
          <SelectItem value="30d">지난 30일</SelectItem>
          <SelectSeparator />
          <SelectItem value="this_month">이번달</SelectItem>
          <SelectItem value="last_month">지난달</SelectItem>
          <SelectSeparator />
          <SelectItem value="custom">기간설정</SelectItem>
        </SelectContent>
      </Select>
      {timeWindow === "custom" && (
        <DatePicker onChange={handleChangeCustomRange} />
      )}
      {groupFilter &&
        groupFilter?.map((group) => (
          <Badge variant="secondary" style={{ border: "1px solid #CCC" }}>
            그룹: {group.name}
            <CircleX
              width={18}
              height={18}
              style={{
                position: "absolute",
                top: "-7px",
                right: "-7px",
                backgroundColor: "#FFF",
                color: "#888",
                cursor: "pointer",
              }}
              onClick={() =>
                setGroupFilter?.(
                  groupFilter?.filter((g) => g.id !== group.id) || [],
                )
              }
            />
          </Badge>
        ))}
      {/*{*/}
      {/*  filter && filter.groups && filter.groups.length > 0 && <Button onClick={() => setFilter?.({})}>필터 초기화</Button>*/}
      {/*}*/}
    </div>
  );
};
